import * as React from 'react';
import { OrderInvoiceStatusMetadata } from '../../../../models/ordering/enums/order-invoice-status';
import { OrderProductionStatusMetadata } from '../../../../models/ordering/enums/order-production-status';
import { OrderShipmentStatusMetadata } from '../../../../models/ordering/enums/order-shipment-status';
import { SearchOrderSummary } from '../../../../models/ordering/search-order-summary';
import './OrderProgress.scss';

type StatusMetadata = { [status: string]: { display: string, class: string } };

interface IStage {
    label       : string;
    metadata    : StatusMetadata;
    getStatus   : (order: SearchOrderSummary) => number;
}

// In the order the work flows
const STAGES: IStage[] = [
    { label: 'Production', metadata: OrderProductionStatusMetadata, getStatus: (o) => o.productionStatus },
    { label: 'Shipment',   metadata: OrderShipmentStatusMetadata,   getStatus: (o) => o.shipmentStatus },
    { label: 'Invoice',    metadata: OrderInvoiceStatusMetadata,    getStatus: (o) => o.invoiceStatus }
];

interface IProps {
    order           : SearchOrderSummary;
}

/**
 * Shows the production, shipment and invoice statuses of an order as a row of three colored
 * segments.  The status of each is available by hovering over its segment.  (The status of the
 * order itself has a column of its own.)
 */
export const OrderProgress = (props: IProps) => {

    const segments = STAGES.map((stage: IStage) => {
        const status = stage.getStatus(props.order);
        const meta = stage.metadata[status];
        return {
            label: stage.label,
            text: meta?.display ?? `${status}`,
            stateClass: meta?.class ?? 'na'
        };
    });

    const summary = segments.map(x => `${x.label}: ${x.text}`).join(', ');

    return <div className="order-progress" role="img" aria-label={ summary }>
        {
            segments.map(x =>
                <span
                    key={ x.label }
                    className={ `order-progress-segment ${x.stateClass}` }
                    title={ `${x.label}: ${x.text}` } />
            )
        }
    </div>;
};
